//-------------------------------------------------------------------------------
// Classe per la gestione delle finestrelle modali di wait, dei dialog ad un pulsante e dei confirm a due.
// Prerequisiti : bootstrap 5 o superiore e jquery
//
// Parametri    :
//     options - rappresentano le proprietà impostabili del dialog.
//
// Remarks      :
//     Utilizzando un template si può aver bisogno di accedere agli eventuali componenti contenuti nel dialog.
//     La selezione si ottiene direttamente via l'id del template oppure con le apposite proprietà GetTemplate e GetContent:
//     es.
//         $('#divModal input').val();
//         dialog.GetTemplate().find('input').focus();
//-------------------------------------------------------------------------------

/* global bootstrap, jQuery */

function customDialog(options) {

	var defaults = {
		width: 'm',           // [s|m|l|x|f] Larghezza del dialog: small, medium, large, extralarge, full screen
		draggable: false,     // Indica se il dialog è trascinabile.
		modalDialogId: null,  // Rappresenta l'id del modal dialog nel caso debba averne uno particolare. Se il parametro rimane a null l'id di default è divModal.
		// Quando si lavora con più di un modal alla volta è indispensabile renderli univoci usando id differenti.
		template: null,       // Rappresenta il template da utilizzare come contenuto del dialog. Nel caso il parametro non sia fornito o è null, viene utilizzato il testo
		// passato come parametro con i metodi di show. Il template rappresenta un oggetto jQuery.
		textCentered: false,   // Se true centra il testo
		showHeader: true,     // In casi particolari non si visualizza l'header
		showFooter: true,     // In casi particolari non si visualizza il footer. Attenzione che i pulsanti di chiusura sono nel footer
		exitButtonLabel: "Exit",        // Testo di default del tasto di uscita.
		confirmButtonLabel: "Confirm", // Testo di default del tasto di conferma.
		cancelButtonLabel: "Cancel",   // Testo di default del tasto di annullamento.
	};

	options = $.extend(defaults, options);

	var _Width = options.width;
	var _Draggable = options.draggable;
	var _DivModalID = options.modalDialogId;
	var _Template = options.template;
	var _ShowHeader = options.showHeader;
	var _ShowFooter = options.showFooter;
	var _TextCentered = options.textCentered;
	var _DialogButtonExit = options.exitButtonLabel;
	var _DialogButtonConfirm = options.confirmButtonLabel;
	var _DialogButtonCancel = options.cancelButtonLabel;
	
	// Test sulla validità dell'ID se fornito
	_DivModalID = /^[^\s]+$/.test(_DivModalID) ? _DivModalID : null;

	var _BootstrapInstance = null;
	var _ModalTmpl = null;

	//#region Public methods and properties

	// -----------------------------------------
	// Metodo per accedere al template passato al dialog.
	// Si può usare anche prima dell'apparizione del dialog.
	// -----------------------------------------
	this.GetTemplate = function () {
		return _Template;
	};

	// -----------------------------------------
	// Metodo per accedere al contenuto del dialog.
	// Si può usare solo dopo l'apparizione del dialog.
	// A differenza di GetTemplate contiene anche gli eventuali dati generati dall'utente o creati al volo.
	// -----------------------------------------
	this.GetContent = function () {
		return $('#' + _DivModalID).find('div.modal-body');
	};

	// -----------------------------------------
	// Nasconde il dialog
	// -----------------------------------------
	this.Hide = function () {
		_Hide();
	};

	// -----------------------------------------
	// Mostra un dialog con il solo pulsante esci
	// Parametri:
	//     text - indica il testo da inserire nel corpo del dialog. Nel caso di template custom passato nel costruttore, text non viene considerato.
	//     title - indica il titolo da inserire in testa al dialog.
	// -----------------------------------------
	this.ShowDialog = function (text, title, confermaCallback) {
		_ShowDialog('dialog', text, title, confermaCallback);
	};

	// -----------------------------------------
	// Mostra un confirm con i pulsanti Ok e Annulla
	// Parametri:
	//     text - indica il testo da inserire nel corpo del dialog. Nel caso di template custom passato nel costruttore, text non viene considerato.
	//     title - indica il titolo da inserire in testa al dialog.
	// -----------------------------------------
	this.ShowConfirm = function (text, title, confermaCallback) {
		_ShowDialog('confirm', text, title, confermaCallback);
	};

	// -----------------------------------------
	// Mostra una finestra di wait
	// -----------------------------------------
	this.ShowWait = function () {
		_ShowDialog('wait');
	};

	//#endregion

	//#region Private Methods

	// -----------------------------------------
	// Funzione per la distruzione del dialog
	// -----------------------------------------
	var _Hide = function () {

		// Rimuove l'evento di monitoraggio dello state della history.
		$(window).off('popstate');
		
		if (_BootstrapInstance != null) {
			// Il dialog viene chiuso con la stessa istanza da cui è stato aperto
			_BootstrapInstance.hide();
			return;
		}

		// Cerca il modal attraverso il suo id in modo da intercettare, a parità di id, anche finestre create con altre istanze
		var modal = document.getElementById(_DivModalID);

		if (modal != null) {
			try {
				bootstrap.Modal.getInstance(modal).hide();
			}
			catch { }
		}
	};

	// -----------------------------------------
	// Funzione di visualizzazione del dialog
	// -----------------------------------------
	var _ShowDialog = function (type, text, title, confermaCallback) {

		var modalAttributes = {
			type: type,
			title: '[Errore: Testo mancante]',
			content: '[Errore: Testo mancante]',
			btnExit: _DialogButtonExit,
			btnCancel: _DialogButtonCancel,
			btnConfirm: _DialogButtonConfirm,
		};

		// Verifica se è stata fornita una callback da scatenare alla chiusura del dialog
		if (confermaCallback === null || confermaCallback === undefined) {
			confermaCallback = function () { };
		}

		// Per prudenza nasconde un eventuale dialog residuo
		_Hide();

		// Determina pulsanti, etichette ed eventi sui pulsanti in base alla finestra scelta
		var bootOptions = {};

		// Imposta il titolo
		//if (title !== null && title !== '') {
		if (title) {
			modalAttributes.title = title;
		}

		// Imposta il testo
		//if (text !== null && text !== '') {
		if (text) {
			modalAttributes.content = text;
		}

		// Carica il dialog con i suoi dati nel body
		// Se non c'è un id custom per il dialog viene usato quello di default
		if (_DivModalID == null) {
			_DivModalID = 'divModal';
		}

		// Carica il markup dinamico di default
		if (modalAttributes.type == 'wait') {
			_ModalTmpl = `
		<div class="modal" tabindex="-1" id="${_DivModalID}" data-bs-backdrop="static" >
			<div class="modal-dialog modal-dialog-centered">
				<div class="modal-content py-3">
					<div class="modal-body align-middle minh-5 text-secondary ">
						<div class="spinner-border spinner-border-sm" role="status">
  						<span class="visually-hidden">Wait...</span>
						</div>
						<!-- Wait... -->
					</div>
				</div>
			</div>
		</div>
	`
		}
		else {
			// Template dei dialog e dei confirm
			_ModalTmpl = `
				<div class="modal" tabindex="-1" id="${_DivModalID}" data-bs-backdrop="true">
					<div class="modal-dialog modal-dialog-centered">
						<div class="modal-content text-secondary">

							<div class="${_ShowHeader ? 'modal-header' : 'd-none'}" >
								<div class="modal-title">${modalAttributes.title}</div>
								<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
									<i class="bi-x-square"></i>
								</button>
							</div>
							<div class="modal-body">${modalAttributes.content}</div>
							<div class="${_ShowFooter ? 'modal-footer' : 'd-none'}" >
								${modalAttributes.type == 'dialog' ?
					'<button type="button" class="btn btnExit" data-bs-dismiss="modal">Exit</button>'
					:
					'<button type="button" class="btn btnConfirm">Confirm</button> ' +
					'<button type="button" class="btn btnCancel" data-bs-dismiss="modal">Cancel</button>'
				}
							</div>
						</div>
					</div>
				</div>
			`;
		}
		
		
		$('body').append(_ModalTmpl);

		// Attiva un riferimento all'elemento del DOM
		var domElement = document.getElementById(_DivModalID)

		// Attiva riferimenti ai vari elementi del dialog
		var modalBody = $(domElement).find('div.modal-body');
		var modalDialog = $(domElement).find('div.modal-dialog');
		var modalHeader = $(domElement).find('div.modal-header');
		var modalFooter = $(domElement).find('div.modal-footer');

		// Il wait dialog è particolare e viene costruito in maniera predefinita
		if (type == 'wait') {
			bootOptions = { 'keyboard': false };
			_TextCentered = true;
			_Width = 'xs';
		}
		else {
			// Se è stato fornito un template svuota il contenuto testuale del dialog per far posto al template stesso
			if (_Template != null) {
				$(modalBody).empty().append(_Template);
			}
		}

		// Centra il testo se necessario.
		if (_TextCentered) {
			$(modalBody).addClass('text-center');
		}	

		// Size
		switch (_Width) {
			case 'xs':
				$(modalDialog).addClass('modal-xs');
				break;
			case 's':
				$(modalDialog).addClass('modal-sm');
				break;
			case 'l':
				$(modalDialog).addClass('modal-lg');
				break;
			case 'x':
				$(modalDialog).addClass('modal-xl');
				break;
			case 'f':
				$(modalDialog).addClass('modal-fullscreen');
				break;
			case 'm':
			default:
				break;
		}

		// Trascinabile
		if (_Draggable) {
			$(modalHeader).drags();
		}

		// Valorizza l'istanza del dialog vero e proprio
		_BootstrapInstance = new bootstrap.Modal(domElement, bootOptions);
		_BootstrapInstance.show();

		// Eventi legati al tipo di modal
		switch (type) {
			case 'dialog':
				// Alla chiusura del dialog viene chiamata la funzione di callback se disponibile
				domElement.addEventListener('hidden.bs.modal', confermaCallback);
				break;

			case 'confirm':
				// Il confirm chiama la callback solo se è premuto il tasto ok
				$(modalFooter).find('button.btnConfirm').on('click', function () {
					// Solo se la funzione di callback chiamata in seguito alla pressione del tasto ok torna true allora il dialog viene nascosto 
					if (confermaCallback()) {
						_BootstrapInstance.hide();
					}
				});
				break;
		}

		// A chiusura avvenuta distrugge i riferimenti al dialog
		domElement.addEventListener('hidden.bs.modal', event => {
			_BootstrapInstance.dispose();
			$('#' + _DivModalID).remove();
		})
		
		if (modalAttributes.type != 'wait') {
			// Monitoraggio dello state della history per tracciare l'apertura del modal
			// Serve ad evitare comportamenti strani rispetto all'hisory back
			history.pushState('forward', undefined, '');
			setTimeout(() => {
				$(window).on('popstate', function () {
			 	_Hide();
			 });
			}, 1000);
		}

		// Mette il focus sul secondo elemento utile (il primo è il pulsante di chiusura in alto a dx)
		$(modalDialog).find(':input:enabled:visible:not([readonly]):nth-child(1)').trigger('focus');
	};

	//#endregion
}

// Aggiunge la funzione drags per permettere lo spostamento del dialog
(function ($) {
	$.fn.drags = function (opt) {

		opt = $.extend({ handle: "", cursor: "move" }, opt);

		var $el = null;
		if (opt.handle === "") {
			$el = this;
		} else {
			$el = this.find(opt.handle);
		}

		return $el.css('cursor', opt.cursor).on("mousedown", function (e) {
			var $drag = null;
			if (opt.handle === "") {
				$drag = $(this).parents('.modal-dialog').addClass('draggable');
			} else {
				$drag = $(this).parents('.modal-dialog').addClass('active-handle').parent().addClass('draggable');
			}
			var z_idx = $drag.css('z-index'),
				drg_h = $drag.outerHeight(),
				drg_w = $drag.outerWidth(),
				pos_y = $drag.offset().top + drg_h - e.pageY,
				pos_x = $drag.offset().left + drg_w - e.pageX;
			$drag.css('z-index', 1000).parents().on("mousemove", function (e) {
				$('.draggable').offset({
					top: e.pageY + pos_y - drg_h,
					left: e.pageX + pos_x - drg_w
				}).on("mouseup", function () {
					$(this).removeClass('draggable').css('z-index', z_idx);
				});
			});
			e.preventDefault(); // disable selection
		}).on("mouseup", function () {
			if (opt.handle === "") {
				$(this).removeClass('draggable');
			} else {
				$(this).removeClass('active-handle').parent().removeClass('draggable');
			}
		});
	}
})(jQuery);


/**------------------------------------
Export of helper functions only for the wait dialog
-------------------------------------*/
const customDialogHelper = {}

var _DialogTimeoutHidden = false;

/**------------------------------------
Mosta un box modale di attesa.
@param {Number} timeout - Se timeout è definito e maggiore di zero significa che il dialog di attesa 
	va mostrato solo dopo un certo numero di ms definito da timeout stesso.
	Passato quel tempo, se hide è già stato chiamato (senza naturalmente poter nascondere nulla) anche 
	show non fa niente. Altrimenti significa che l'escuzione è ancora in corso e il dialog va mostrato.
-------------------------------------*/
customDialogHelper.ShowWaitDialog = function (timeout) {
	if (timeout && timeout > 0) {
		
		setTimeout(() => {
			if (!_DialogTimeoutHidden) {
				var dialog = new customDialog({ modalDialogId: "divModalCommon" });
				dialog.ShowWait();
			}
		}, timeout);
	}
	else {
		var dialog = new customDialog({ modalDialogId: "divModalCommon" });
		dialog.ShowWait();
	}
};

//-------------------------------------------------------------------------------
// Nasconde il box modale di attesa se presente.
//-------------------------------------------------------------------------------
customDialogHelper.HideWaitDialog = function () {
	_DialogTimeoutHidden = true;
	var dialog = new customDialog({ modalDialogId: "divModalCommon" });
	dialog.Hide();
};

customDialogHelper.genericDialog = customDialog; 

export default customDialogHelper;